import { normalizeSort } from '../utils'
import GruaService from '../services/GruaService'

const state = () => ({
  list: [],
  pagination: {
    page: 1,
    itemsPerPage: 10,
    sortBy: ['date_inicial'],
    sortDesc: [false]
  }
})

const getters = {
  GRUAS: state => {
    return state.list
  },
  GRUAS_PAG: state => {
    return state.pagination
  }
}

const mutations = {
  SET_GRUAS: (state, payload) => {
    state.list = payload
  },
  SET_GRUAS_PAG: (state, payload) => {
    state.pagination = payload
  },
  DELETE_GRUA: (state, payload) => {
    payload.status = 0
    payload.status_description = 'Deshabilitado'
    state.list = state.list.map(el => el.id === payload.id ? payload : el)
  },
  ENABLE_GRUA: (state, payload) => {
    payload.status = 1
    payload.status_description = 'Habilitado'
    state.list = state.list.map(el => el.id === payload.id ? payload : el)
  },
  ADD_GRUA: (state, payload) => {
    state.list.push(payload)
  },
  UPDATE_GRUA: (state, payload) => {
    state.list = state.list.map(el => el.id === payload.id ? payload : el)
  }
}

const actions = {
  LOAD_GRUAS: async ({ commit, state }, filter) => {
    try {
      let pagination = {
        'page': state.pagination.page,
        'per-page': state.pagination.itemsPerPage,
        'sort': normalizeSort(state.pagination.sortBy, state.pagination.sortDesc)
      }

      let currentFilter = {}
      for (let key in filter) {
        if (filter.hasOwnProperty(key)) {
          currentFilter[`filter[${key}]`] = filter[key]
        }
      }

      let { data, status } = await GruaService.get({ ...currentFilter, ...pagination })
      if (status === 200) {
        commit('SET_GRUAS', data.data)
        return data._meta.totalCount
      }
    } catch (error) {
      window.app.$toast.error('Ocurrió un problema al intentar obtener la lista de Grua')
      console.error(error)
    }
  },
  VIEW_GRUA: async (obj, params) => {
    try {
      let { data, status } = await GruaService.view(params)
      if (status === 200) {
        return data
      }
    } catch (error) {
      console.error(error)
      window.app.$toast.error('Ocurrió un problema al intentar obtener los detalles de los Grua')
    }
  },
  ADD_GRUA: async ({ commit }, payload) => {
    try {
      let { data, status } = await GruaService.post(payload)
      if (status === 201) {
        commit('ADD_GRUA', data)
        window.app.$toast.success('El conductor ha sido registrado satisfactoriamente')
      }
      return { error: false, data, status }
    } catch (error) {
      return { error: true, data: error.response.data, status: error.response.status }
    }
  },
  UPDATE_GRUA: async ({ commit }, payload) => {
    try {
      let { data, status } = await GruaService.put(payload)
      if (status === 200) {
        commit('UPDATE_GRUA', data)
        window.app.$toast.success('El conductor ha sido actualizado satisfactoriamente')
      }
      return { error: false, data, status }
    } catch (error) {
      return { error: true, data: error.response.data, status: error.response.status }
    }
  },
  DELETE_GRUA: async ({ commit }, payload) => {
    try {
      let { status } = await GruaService.delete(payload)
      if (status === 204) {
        commit('DELETE_GRUA', payload)
        window.app.$toast.success('El conductor ha sido deshabilitado satisfactoriamente')
      }
    } catch (error) {
      console.error(error)
      window.app.$toast.error('Ocurrió un problema al intentar deshabilitar el usuario')
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
